/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import cn from 'classnames'
import { map, some, get, flatten, size, isNumber, debounce } from 'lodash'

import SidebarModal from './SidebarModal'
import Button from './Button'
import QuantityEntryModal from '../containers/QuantityEntryModal'
import NotesEntryModal from './NotesEntryModal'
import ModifierGroup from './ModifierGroup'

import quantityValidator from '../utils/quantityValidator'
import quantityUpdater from '../utils/quantityUpdater'
import { NOTES_CHARACTER_LIMIT } from '../constants'

import styles from './CartItemDetailsModal.module.scss'

const CartItemDetailsModal = ({ dispatch, orderMaxAmount, orderMinCount, id, title, price, quantity, canEnterNotes, notes, notesAreEmpty, modifierGroups, selectedItemIds, onClose, onRemove, className, addToCart, subtractFromCart, updateModifiers, updateNotes, incrementQuantity, decrementQuantity, ...props }) => {
  const classNames = cn(styles.cartItemDetailsModal, className)
  const [modifierGroupsSelections, setModifierGroupsSelections] = useState(selectedItemIds)
  const [validators, setValidators] = useState(map(modifierGroups, ({ min, max }) => quantityValidator(min, max)))
  const [isValid, setIsValid] = useState(false)
  const isMaxQuantity = quantity === orderMaxAmount
  const isMinQuantity = quantity === orderMinCount || quantity === 1
  const [showQuantityEntryModal, setShowQuantityEntryModal] = useState(false)
  const previousCartQuantityRef = useRef()
  const onSelect = (itemId, index) => {
    const modifierGroup = modifierGroups[index]
    const { min, max } = modifierGroup
    const selectedModifiers = modifierGroupsSelections[index]

    const nextSelectedModifiers = [...modifierGroupsSelections]
    nextSelectedModifiers[index] = quantityUpdater(min, max, selectedModifiers, itemId)

    setModifierGroupsSelections(nextSelectedModifiers)
    updateModifiers(flatten(nextSelectedModifiers))
  }

  useEffect(() => {
    const validations = map(validators, (validator, index) => {
      const modifierGroupSelections = modifierGroupsSelections[index]

      return validator.isValid(get(modifierGroupSelections, 'length', 0))
    })

    const isValid = !some(validations, (valid) => valid === false)
    setIsValid(isValid)

  }, modifierGroupsSelections)

  useEffect(() => {
    setValidators(map(modifierGroups, ({ min, max }) => quantityValidator(min, max)))
    setModifierGroupsSelections(selectedItemIds)
  }, [modifierGroups])

  let quantityEntryModal = null
  let notesEntryModal = null
  let notesElement = null

  if (showQuantityEntryModal) {
    quantityEntryModal = (
      <QuantityEntryModal
        id={id}
        onClose={() => setShowQuantityEntryModal(false)}
      />
    )
  }

  const hasCharacterMax = isNumber(NOTES_CHARACTER_LIMIT)
  const characterCount = size(notes)
  const characterCountString = `${characterCount}${hasCharacterMax ? `/${NOTES_CHARACTER_LIMIT}` : ''}`

  const handleSetNotes = (event) => {
    const notes = get(event, 'target.value', '')
    let trimmedNotes = notes

    if (hasCharacterMax) {
      trimmedNotes = notes.substring(0, NOTES_CHARACTER_LIMIT)
    }

    updateNotes(trimmedNotes)
  }

  if (canEnterNotes) {
    notesElement = (
      <div className={cn(styles.notesContainer, { [styles.emptyNotes]: notesAreEmpty })}>
        <textarea
          placeholder="Add Special Instructions"
          value={notes}
          onChange={handleSetNotes}
          className={styles.notes}
        />
        <span className={styles.characterCount}>{characterCountString}</span>
      </div>
    )
  }

  const handleQuantityChange = (quanityChangeFunc) => {
    if (quantity === 0 || quantity !== previousCartQuantityRef?.current) {
      previousCartQuantityRef.current = quantity
      quanityChangeFunc()
    }
  }

  return (
    <>
      <SidebarModal show title="Item Detail" onClose={() => onClose(isValid, id)} className={classNames} {...props} >
        <div className={styles.cartItemDetailsModal}>
          <div className={styles.header}>
            <div className={styles.itemName}>{title}</div>
            {/* <div className={styles.itemDescription}>Item Description TODO</div> */}
            <div className={styles.price}>{price}</div>
            <div>
              {/* <Button
                className={styles.buttonRemove}
                onClick={() => onRemove(id)}
              >
                Remove
              </Button> */}
            </div>
          </div>
          {modifierGroups.map((modifierGroup, index) => {
            if(!modifierGroup.name) {
              return null
            }
            return (
              <ModifierGroup
                key={index}
                className={styles.modifierGroup}
                title={modifierGroup.name}
                label={get(validators, `[${index}].label`)}
                items={modifierGroup.items}
                selectedItemIds={modifierGroupsSelections[index]}
                isRequired={get(validators, `[${index}].validationType`) === quantityValidator.types.required}
                min={modifierGroup.min}
                max={modifierGroup.max}
                onSelect={(itemId) => onSelect(itemId, index)}
                uuid={modifierGroup.uuid}
              />
            )
          })}
          {notesElement}
          <div className={styles.footer}>
            <div className={styles.updateQuantity}>
              <span className={isMinQuantity ? styles.disabled : styles.quantityOperator} onClick={debounce(() => handleQuantityChange(decrementQuantity), 50)} >–</span>
              <span className={styles.quantity} onClick={() => setShowQuantityEntryModal(true)}>{quantity}</span>
              <span className={isMaxQuantity ? styles.disabled : styles.quantityOperator} onClick={debounce(() => handleQuantityChange(incrementQuantity), 50)}>+</span>
            </div>
            <div className={styles.update}>
              <Button className={styles.doneButton} disabled={!isValid} onClick={onClose}><span>Update</span></Button>
            </div>
          </div>
        </div>
      </SidebarModal>
      {quantityEntryModal}
      {notesEntryModal}
    </>
  );
}

export default CartItemDetailsModal
